import { render, staticRenderFns } from "./M2T.vue?vue&type=template&id=54d9a8e2&scoped=true"
import script from "./M2T.vue?vue&type=script&lang=js"
export * from "./M2T.vue?vue&type=script&lang=js"
import style0 from "./M2T.vue?vue&type=style&index=0&id=54d9a8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d9a8e2",
  null
  
)

export default component.exports